import React, { CSSProperties } from "react";
import { Input, InputProps } from "reactstrap";
import { IControlStyles, useControlStyles } from "../.";
import { useField } from "formik";
import { ControlProps } from "../../control";
import { FormatHelper } from "../../../../utils/helpers";

export interface ControlTemplateProps extends Omit<ControlProps, "type"> {
    isHidden?: boolean | undefined;
}

export const ComponentProps = (props: ControlTemplateProps): ControlProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.controlStyles;


    return componentProps;
};

const ComponentInputProps = (props: ControlProps): InputProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.controlStyles;
    delete componentProps.isHidden;

    return componentProps;
};

export const ControlInput: React.FC<ControlProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ?? useControlStyles();
    const [field, meta] = useField(props.name ?? "");
    const { onChange: fieldOnChange, value: fieldValue } = field;
    let inputValue = fieldValue ?? "";
    const [inputChecked, setInputChecked] = React.useState<boolean | undefined>(() => {
        switch (props.type) {
            case "radio":
                return fieldValue === props.value;
            case "checkbox":
            case "switch":
                return Boolean(props.checked);
            default:
                return undefined;
        }
    });

    const inputRef = React.useRef<HTMLInputElement>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (props.type === "switch") {
            if (inputRef.current) {
                setInputChecked(e.target.checked)
            }
        }

        if (props.onChange) {
            props.onChange(e);
        }
        fieldOnChange(e);
    };

    React.useEffect(() => {

        switch (props.type) {
            case "radio":
                setInputChecked(fieldValue === props.value);
                inputValue = props.value;
                break;
            case "checkbox":
                inputValue = Boolean(props.value)
                setInputChecked(Boolean(props.checked))
                break;
            case "switch":
                inputValue = inputValue ?? props.checked
                setInputChecked(inputChecked ?? props.checked)
                break;
            case "date":
                inputValue = inputValue ? FormatHelper.formatDateForDatePicker(fieldValue) : "";
                break;
            case "datetime-local":
                inputValue = inputValue ? FormatHelper.formatDateTimeForDatePicker(fieldValue) : "";
                break;
            default:
                inputValue = inputValue ?? fieldValue ?? "";
                break;
        }
    }, [props]);

    const isHidden: boolean = props.isHidden ?? false;
    const inputStyle: CSSProperties | undefined = isHidden ? { display: "none" } : undefined;
    const isDateLikeInput = ["date", "datetime-local", "month", "time", "week"].includes(props.type ?? "");
    const isSwitch = props.type === "switch";
    const className = [
        isSwitch ? "control-switch-input" : "form-control",
        isDateLikeInput ? "themed-date-input" : undefined,
        meta?.error ? "is-invalid" : undefined,
        props.className,
    ].filter(Boolean).join(" ");

    const inputElement = (
        <Input
            {...ComponentInputProps(props)}
            placeholder={props.placeholder ?? ""}
            innerRef={inputRef}
            id={props.name}
            name={props.name}
            value={inputValue}
            checked={inputChecked}
            onChange={handleChange}
            invalid={meta?.touched && !!meta?.error}
            className={className}
            style={isSwitch ? inputStyle : { ...styles.input, ...props.style, ...inputStyle }}
        />
    );

    if (isSwitch) {
        return (
            <>
                <span className="control-switch-wrapper">
                    {inputElement}
                    <span className="control-switch-track" aria-hidden="true" />
                </span>
                {meta?.error && <div className="invalid-feedback">{meta?.error}</div>}
            </>
        );
    }

    return (
        <>
            {inputElement}
            {meta?.error && <div className="invalid-feedback">{meta?.error}</div>}
        </>
    );
};